/**
 * @packageDocumentation
 * @module f1/is
 */

export interface IsArray {
  /**
   * Is the value an array
   *
   * @public
   * @function f1.is.array
   * @example
   *
   * ```ts
   * f1.is.array({}) => false
   * f1.is.array([]) => true
   * ```
   */
  (value: unknown): value is unknown[];
}

/**
 * @see IsArray
 */
export default (value: unknown): value is unknown[] => {
  return Array.isArray(value);
};
